export default __webpack_public_path__ + "static/media/marker.aba9ec04.png";